import { createContext, useContext, useEffect, useReducer } from 'react';
import ajaxExpenses from '../util/remote/ajaxExpenses';
import { get } from 'jquery';

const initialState = { 
    incomingInvoiceListing: null,
    unpaidInvoiceCount: 0,
    metaData: null,
    currentPage: 1,
    mounted: false,
    recentOutstandingListing: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'CLEAR':
      return { initialState};  // Reset state completely
    default:
      return {...state, [action.type]: action.payload};
  }
  };


const IncomingInvoiceContext = createContext();

export const IncomingInvoiceProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(()=>{
    if(state.mounted){
      getInvoiceTransactions(false ,true);
    }
  }, [state.currentPage])
 

  const getUnpaidInvoiceCount = async (refresh = false) => {
    if(!refresh && state.unpaidInvoiceCount > 0){
      return;
    }
    const server_response  = await ajaxExpenses.fetchOutstandingInvoiceCount();
    if(server_response.status === "OK"){
        dispatch({ type: 'unpaidInvoiceCount', payload: server_response.details });
    }
  };

  const getInvoiceTransactions = async(refresh = false, nextPage=false)=>{
      dispatch({type: 'mounted', payload: true});

      if(!refresh && Array.isArray(state.incomingInvoiceListing) && !nextPage){
        return
      }

    const server_response = await ajaxExpenses.fetchInvoiceRecords({
      page: state.currentPage,
    });
    dispatch({ type: 'incomingInvoiceListing', payload: null });
    dispatch({ type: 'metaData', payload: null });
    if(server_response.status==="OK"){
      dispatch({ type: 'incomingInvoiceListing', payload: server_response.details.data });
      dispatch({ type: 'metaData', payload: server_response.details.meta });
    }else{
      dispatch({ type: 'incomingInvoiceListing', payload: "404" });
      dispatch({ type: 'metaData', payload: "404" });

    }
  }


  /**
   * Only returns 30 records, for more records click view all
   */
  const getOutstandingInvoices = async(refresh=false)=>{
    if(!refresh && Array.isArray(state.recentOutstandingListing)){
      return;
    }
    const server_response = await ajaxExpenses.fetchOutstandingInvoices();
    if(server_response.status==="OK"){
      dispatch({ type: 'recentOutstandingListing', payload: server_response.details });
    }else{
      dispatch({ type: 'recentOutstandingListing', payload: "404" });
    }
  }

  const refresh = async() =>{ 
    await getUnpaidInvoiceCount(true);
    await getOutstandingInvoices(true);
    await getInvoiceTransactions(true);
  }

  const setCurrentPage = (page)=>{
    dispatch({type: 'currentPage', payload: page});
  }

  return(
    <IncomingInvoiceContext.Provider value={{
      ...state, 
      dispatch, 
      getUnpaidInvoiceCount,
      getInvoiceTransactions,
      refresh,
      setCurrentPage,
      getOutstandingInvoices,
      }}>
      {children}
    </IncomingInvoiceContext.Provider>
  )

}

export const useIncomingInvoice = ()=>useContext(IncomingInvoiceContext);

